module.exports = __webpack_public_path__ + "img/Group 427320597.28685e69.png";